// extracted by mini-css-extract-plugin
export default {"phoneAreaCode":"style_phoneAreaCode__3Hr+j"};